import React from 'react';
import {ErrorModal} from '@igp/shared/components/error';
import {withTraceErrorBoundary} from '@igp/shared/otel';

import {withAccessCheck} from '@access-control';

import {playerLevelReportPlayerEcologyResource} from './permissions';
import {PlayerLevelReportBase} from './PlayerLevelReportBase';

function PlayerLevelReportPlayerEcologyInner() {
    return <PlayerLevelReportBase tab="playerEcology" columnsSettingsViewType="PlayerLevelReportPlayerEcology" hasTotalRow={false} />;
}

const PlayerLevelReportPlayerEcologyWithAccess = withAccessCheck(
    PlayerLevelReportPlayerEcologyInner,
    playerLevelReportPlayerEcologyResource
);

export const PlayerLevelReportPlayerEcology = withTraceErrorBoundary(PlayerLevelReportPlayerEcologyWithAccess, ErrorModal);
